<template>
  <v-expansion-panels  multiple variant="accordion">
    <v-expansion-panel
      style="border-radius: 0"
      v-for="(item,i) in items"
      :key="i"
      @click="setCurrentItemUnset(item);"
    >
      <v-divider></v-divider>
      <v-expansion-panel-title
        @contextmenu.prevent="setCurrentItemUnset(item);
            isLocked || show($event)"
      >
        <template v-slot:default="{ expanded }">
          <UniformLoadHeader :item="item" :open="expanded" />
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-row>
          <v-col>
            <UniformLoad :item="item" />
          </v-col>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
    <TableActionMenu
      @update:show-menu="showMenu = $event"
      :show-menu="showMenu" :x="x" :y="y"
                     :add-button="false"
                     @action="deleteItem(currentItem.id)"

    />

  </v-expansion-panels>
</template>
<script>
  import UniformLoad from "@/components/loads/UniformLoad.vue"
  import UniformLoadHeader from "@/components/loads/UniformLoadHeader.vue"
  import { mapActions, mapGetters, mapState } from "vuex"
  import ShowActionMenuMixin from "@/mixins/ShowActionMenuMixin.vue"
  import TableActionMenu from "@/components/common/TableActionMenu.vue"

  export default {
    name: "UniformLoads",
    components: { UniformLoad, UniformLoadHeader, TableActionMenu },
    mixins: [ShowActionMenuMixin],
    props: {},
    computed: {
      ...mapState("uniformLoads", {
        items: state => state.items,
        currentItem: state => state.currentItem,
        writeLoading: state => state.writeLoading
      }),
      ...mapGetters("stabSchematisation", {
        isLocked: "isLockedCurrent"
      })
    },
    methods: {
      ...mapActions("uniformLoads", {
          setCurrentItem: "setCurrentItem",
          deleteItem: "deleteItem"
        }
      ),
      ...mapActions("treeLoads", {
          setCurrentItemTree: "setCurrentItem"
        }
      ),
      setCurrentItemUnset (item) {
        this.setCurrentItem(item)
        this.setCurrentItemTree(null)
      }
    }
  }
</script>

<style scoped>
  .border-right {
    border-right: solid 1px rgba(0, 0, 0, 0.25);
  }

</style>
